import store from '@/store'

export default [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@/views/Home.vue')),
    meta: {
      title: 'Gloednieuw overhoorprogramma om gratis woordjes online te leren en overhoren',
      showFooter: true,
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@/views/Login.vue')),
    meta: {
      title: 'Inloggen',
      showFooter: false
    }
  },
  {
    path: '/requestpassword',
    component: () => lazyLoadView(import('@/views/RequestPassword.vue')),
    meta: {
      title: 'Wachtwoord vergeten',
      requiresAuth: false,
    }
  },
  {
    path: '/resetpassword/:code',
    props: true,
    component: () => lazyLoadView(import('@/views/ResetPassword.vue')),
    meta: {
      title: 'Wachtwoord resetten',
      requiresAuth: false,
    }
  },
  {
    path: '/aanmelden',
    component: () => lazyLoadView(import('@/views/Register.vue')),
    meta: {
      title: 'Aanmelden',
      requiresAuth: false,
      showFooter: false
    }
  },
  {
    path: '/quizlet-alternatief',
    component: () => lazyLoadView(import('@/views/Landing/Quizlet-alternatief.vue')),
    meta: {
      title: 'Een goed Quizlet alternatief',
      requiresAuth: false,
      showFooter: true,
      isBlue: true
    }
  },
  {
    path: '/woordjes-leren',
    component: () => lazyLoadView(import('@/views/Landing/Woordjes-leren.vue')),
    meta: {
      title: 'Woordjes leren met Ikleeralles.nl',
      requiresAuth: false,
      showFooter: true,
      isBlue: true
    }
  },
  {
    path: '/topografie',
    component: () => lazyLoadView(import('@/views/Landing/Topografie.vue')),
    meta: {
      title: 'Topografie oefenen met Ikleeralles.nl',
      requiresAuth: false,
      showFooter: true,
      isBlue: true
    }
  },
  {
    path: '/blog',
    component: () => lazyLoadView(import('@/views/Blog/Blog.vue')),
    meta: {
      title: 'Blog',
      requiresAuth: false,
      isBlue: true
    }
  },
  {
    path: '/blog/:id',
    props: true,
    component: () => lazyLoadView(import('@/views/Blog/Post.vue')),
    meta: {
      title: 'Blog',
      requiresAuth: false,
      isBlue: true
    }
  },
  {
    path: '/contact',
    component: () => lazyLoadView(import('@/views/Contact.vue')),
    meta: {
      title: 'Contact',
      requiresAuth: false,
    }
  },
  {
    path: '/education',
    component: () => lazyLoadView(import('@/views/UpdateEducation.vue')),
    meta: {
      title: 'Opleiding bijwerken',
      requiresAuth: true,
    },
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '/',
  },
  {
    path: '/join',
    beforeEnter() {
      window.location.href = 'http://woordjes.ikleeralles.nl/join'
    }
  },
  {
    path: '/join/:code',
    beforeEnter(to) {
      window.location.href = 'http://woordjes.ikleeralles.nl/join/' + to.params.code;
    }
  },
  {
    path: '/race',
    beforeEnter() {
      window.location.href = 'http://woordjes.ikleeralles.nl/race'
    }
  },
  {
    path: '/race/:code',
    beforeEnter(to) {
      window.location.href = 'http://woordjes.ikleeralles.nl/race/' + to.params.code;
    }
  }
]

function lazyLoadView(AsyncView) {
  let AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@/views/Loading.vue').default,
    delay: 1000,
    error: require('@/views/Timeout.vue').default,
    timeout: 5000
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    }
  })
}
